<script lang="ts">
    import { connection } from "./lib/connection.svelte.ts";
    import { room } from "./lib/room.svelte.ts";
    import Background from "./components/Background.svelte";
    import ContextMenu from "./components/ContextMenu.svelte";
    import InputBar from "./components/InputBar.svelte";
    import Login from "./components/Login.svelte";
    import Logo from "./components/Logo.svelte";
    import OutputWindow from "./components/OutputWindow.svelte";
    import RoomPanel from "./components/RoomPanel.svelte";

    $effect(() => {
        const parts: string[] = [];
        if (connection.status === "connected") {
            if (room.title)    parts.push(room.title);
            if (room.areaName) parts.push(room.areaName);
        }
        parts.push(room.worldTitle);
        document.title = parts.join(" « ");
    });

    function refocusInput(e: MouseEvent) {
        const target = e.target as Element;
        if (target.closest("input, button, a, select, textarea, .cm-editor")) return;
        if (window.getSelection()?.toString()) return;
        document.querySelector<HTMLInputElement>(".input-bar input")?.focus();
    }
</script>

<Background />
<ContextMenu />

{#if connection.status === "disconnected" || connection.status === "error"}
    <Login />
{:else if connection.status === "connected"}
    <!-- svelte-ignore a11y_click_events_have_key_events -->
    <!-- svelte-ignore a11y_no_static_element_interactions -->
    <div class="layout" role="presentation" onclick={refocusInput}>
        <div class="left-pane">
            <OutputWindow />
            <Logo />
            <InputBar />
        </div>
        <div class="right-pane">
            <RoomPanel />
        </div>
    </div>
{/if}

<style>
    .layout {
        position: fixed;
        inset: 0;
        z-index: 1;
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        gap: 1.5rem;
        padding: 1rem 1.5rem 0.75rem;
        overflow: hidden;
    }

    .left-pane {
        flex: 0 1 120ch;
        min-width: 0;
        max-width: 120ch;
        height: 100%;
        display: flex;
        flex-direction: column;
        gap: 0;
    }

    .right-pane {
        flex: 1 1 0;
        min-width: 0;
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    @media (max-width: 900px) {
        .layout {
            flex-direction: column;
            overflow-y: auto;
        }
        .left-pane {
            flex: 0 0 auto;
            height: auto;
            max-width: 100%;
        }
        .right-pane {
            display: none;
        }
    }
</style>
